const { qs, qsa, build, apc, isHover, midilearn } = require('../../libs/qs')
const uuid = require("uuid").v4
const { createFaderH, createFaderV, createSelector, createBtnctrlor } = require('@azopsoft/shared/ui').ctrlz
// const Knob=require('../../common/knob')
// const Fader=require('./cfader')
const VanillaContextMenu = require('vanilla-context-menu')
const lib = {}

let store

lib.setStore = (s) => {
    store = s
}

// lib.knob=(input)=>{


//    const k= Knob({
//         className:'zknob',
//         input:input,
//         label: input.dataset.label,
//         value: input.value,
//         angleOffset: -180,
//         angleArc: 360,
//         step: Number(input.step),
//         min: Number(input.min),
//         max: Number(input.max),
//         width: 50,
//         height: 50,
//          //cursor:true,
//         labelColor: `rgb(${store.palletes[store.theme][10].r}, ${store.palletes[store.theme][10].g}, ${store.palletes[store.theme][10].b})`,
//         bgColor: `rgb(${store.palletes[store.theme][1].r}, ${store.palletes[store.theme][1].g}, ${store.palletes[store.theme][1].b})`,
//         fgColor: `rgb(${store.palletes[store.theme][10].r}, ${store.palletes[store.theme][10].g}, ${store.palletes[store.theme][10].b})`,
//     })
//     console.log(k.element)

// }


lib.dualrange = require('@azopsoft/shared/ui').ctrlz.dualrange




lib.faderH = createFaderH({ qs, qsa, build, apc, isHover, midilearn, uuid, VanillaContextMenu })
lib.faderV = createFaderV({ qs, qsa, build, apc, isHover, midilearn, uuid, VanillaContextMenu })

const { createUnassignable } = require('@azopsoft/shared/ui').ctrlz
lib.unassignable = createUnassignable({ qs, uuid })

lib.selector = createSelector({ build, midilearn, VanillaContextMenu })

lib.btnctrlor = createBtnctrlor({ build, midilearn, VanillaContextMenu })

module.exports = lib